import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IUserInfoLogin } from '../../../models/request-and-responses/rest-api/interfaces/userInfoLogin';
import { IUserWithAnagraphic } from '../../../models/request-and-responses/rest-api/interfaces/userWithAnagraphic';
import { ContractPermission } from '../../../models/request-and-responses/rest-api/enums/contractPermission';
import { PataviumRole } from '../../../models/request-and-responses/rest-api/enums/role.enum.model';
import { AuthService } from '../../../services/auth.service';
import { ResetPasswordParams } from '../../../components/password-reset/password-reset.component';
import { SessionStorageService } from '../../../services/session-storage.service';
import { catchError, finalize, tap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    public loginError: Boolean = false;
    public userForm = new FormGroup({
        username: new FormControl(null, Validators.compose([Validators.required])),
        password: new FormControl(null, Validators.compose([Validators.required]))
    });
    public isLogging = false;

    constructor(
        private auth: AuthService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private toastr: ToastrService
    ) {
        this.activatedRoute.queryParams.subscribe(response => {
            if (
                response[ResetPasswordParams.UserId] != null &&
                response[ResetPasswordParams.Token] != null
            ) {
                this.router.navigate(['password-reset'], { preserveQueryParams: true });
            }
        });
    }

    ngOnInit() {}

    private storeUserInfoAndRedirect(user: IUserWithAnagraphic, route: string) {
        console.debug(`storeUserInfoAndRedirect`, user, route);
        const role = user.user.rUsersRoles[0].idRole;
        const id = user.user.rUsersRoles[0].idUser;
        const brands = user.permitBrands || [];
        let permitContracts = String(Number(ContractPermission.None));
        if (user.permitContracts != null) {
            permitContracts = String(Number(user.permitContracts));
        }
        const username = user.user.username || PataviumRole[Number(role)];
        SessionStorageService.role.save(role.toString());
        SessionStorageService.id.save(id.toString());
        SessionStorageService.brands.save(JSON.stringify(brands));
        SessionStorageService.permitContracts.save(permitContracts);
        SessionStorageService.username.save(username);
        if (role === PataviumRole.Agent || role === PataviumRole.AgencyOperator) {
            const agencyId = user.user.rUsersGroupsIdGroupNavigation[0].idGroup;
            SessionStorageService.agencyid.save(agencyId.toString());
        }
        SessionStorageService.canExportContract.save(user.user.canExportContract.toString());
        SessionStorageService.canDoExportSemplice.save(user.user.canDoExportSemplice !== null  ? user.user.canDoExportSemplice.toString() : null);
        SessionStorageService.canDoExportGas.save(user.user.canDoExportGas !== null ? user.user.canDoExportGas.toString() : null);
        SessionStorageService.canDoExportEe.save(user.user.canDoExportEe !== null ? user.user.canDoExportEe.toString() : null);
        SessionStorageService.email.save(user.user.email);
        SessionStorageService.customerVisibility.save(user.user.customerVisibility);
        SessionStorageService.teleselling.save(user.user.teleselling.toString());
        SessionStorageService.cf.save(user.anagraphicUser.fiscalCode);
        SessionStorageService.fullName.save(user.anagraphicUser.fullName);
        let adesioneADistanza = user.user.canDoAdesioneADistanza;
        if (adesioneADistanza == null) {
            adesioneADistanza = false;
        }
        SessionStorageService.canDoAdesioneADistanza.save(adesioneADistanza.toString());
        const commands = [route];
        setTimeout(() => {
            console.debug(`Navigating towards ${route}`);
            this.router
                .navigate(commands)
                .catch(err =>
                    console.error(`Impossibile navigare verso la rotta '${commands}'`, err)
                );
        }, 500);
    }

    async login() {
        const userInfo: IUserInfoLogin = {
            username: this.userForm.value.username,
            password: this.userForm.value.password,
            application: environment.application_name,
            browser: window.navigator.userAgent,
            screenSize: AuthService.getScreenSize()
        };
        this.isLogging = true;
        this.auth
            .login(userInfo)
            .pipe(
                tap(res => {
                    SessionStorageService.clear();
                    if (res.headers) {
                        const token = res.headers.get('X-Token');
                        SessionStorageService.jwt.save(token);
                        const user = res.body.item;
                        if (
                            user &&
                            user.user.rUsersRoles &&
                            user.user.rUsersRoles.length &&
                            user.user.rUsersRoles[0].idRole
                        ) {
                            switch (user.user.rUsersRoles[0].idRole) {
                                case PataviumRole.Admin:
                                    this.storeUserInfoAndRedirect(user, '/superadmin/dashboard');
                                    break;
                                case PataviumRole.BackOfficeOperator:
                                    this.storeUserInfoAndRedirect(user, '/admin/dashboard');
                                    break;
                                case PataviumRole.Agency:
                                    this.storeUserInfoAndRedirect(user, '/agency/dashboard');
                                    break;
                                case PataviumRole.Agent:
                                    this.storeUserInfoAndRedirect(user, '/agent/dashboard');
                                    break;
                                case PataviumRole.AgencyOperator:
                                    this.storeUserInfoAndRedirect(
                                        user,
                                        '/agency-operator/dashboard'
                                    );
                                    break;
                                case PataviumRole.SpecializedOperator:
                                    this.storeUserInfoAndRedirect(
                                        user,
                                        '/specialized-operator/contracts/contracts'
                                    );
                                    break;
                            }
                        }
                    }
                }),
                catchError(err => {
                    console.error(`Error occurred trying to login`, err);
                    this.toastr.error(`Si è verificato un errore durante il login`);
                    SessionStorageService.clear();
                    return EMPTY;
                }),
                finalize(() => {
                    this.isLogging = false;
                })
            )
            .subscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/common/login/login.component.ts